import React from 'react';
import { GeneralFila } from '../../../Models/General';
import FilaCotizacion from './FilaCotizacion'
import { Link } from 'react-router-dom';
import Avanzado, { AvanzadosProps } from '../../../Utiles/Componentes/Avanzado';
import { conCotizacion } from '../../../Models/Ventas';
import CardBuscador from '../../../Utiles/Buscadores/Card';
import { Producto } from '../../../Models/Productos';
import { CotizacionContext } from '../../../Context/Ventas/Cotizacion';
import CotizacionExcel from './Excel';
import { Col } from 'react-bootstrap';
class ListCotizaciones extends CardBuscador {
    con = conCotizacion();
    placeholder = "BUSCAR COTIZACIÓN";
    buscarEn = ["codigo", "nombre", 'fecha', 'rif'];
    fecha_init = 'dd/mm/aaaa';
    fecha_fin = 'dd/mm/aaaa';
    productos: Producto[] = []
    status = -1;
    user = -1;
    Avansado() {
        const { fecha_init, fecha_fin, status, user, productos, setAvanzados } = this;
        return <Avanzado setData={setAvanzados.bind(this)}
            estatus={['CANCELADO', 'PENDIENTE', 'PROCESADA']}
            fecha_init={fecha_init} fecha_fin={fecha_fin}
            status={status} user={user} productos={productos} />
    }
    setAvanzados({ fecha_init, fecha_fin, status, user, productos }: AvanzadosProps) {
        if (fecha_init) this.fecha_init = fecha_init;
        if (fecha_fin) this.fecha_fin = fecha_fin;
        if (user) this.user = user;
        if (status) this.status = status;
        if (status === 0) this.status = status;
        if (productos) this.productos = productos;
        this.forceUpdate()
    }
    filter() {
        const { fecha_init, fecha_fin, status, user, productos, datetonomber } = this;
        let itens = this.ordenar();
        return itens.filter((c: GeneralFila) => {
            if (c.status !== status && status !== -1) return false;
            if (c.usuario !== user && user !== -1) return false;
            const creacion = datetonomber(c.fecha);
            if (fecha_fin !== 'dd/mm/aaaa' && creacion > datetonomber(fecha_fin)) return false;
            if (fecha_init !== 'dd/mm/aaaa' && creacion < datetonomber(fecha_init)) return false;
            if (!productos.every(p => c.detalles.some(d => p.codigo === d))) return false;
            return true;
        });
    }
    Title() {
        return <>
            <h4 className='mr-auto'><i className="fa fa-search"></i> BUSCAR COTIZACIÓN</h4>
            <Link to="/cotizacion/nueva" className="btn btn-primary"><span className="fa fa-plus"></span> NUEVA COTIZACION</Link>
        </>
    }
    Header() {
        const { Th } = this;
        return <tr className="info">
            <Th label='codigo' width='100px'>N°</Th>
            <Th label='fecha' width='120px'>FECHA</Th>
            <Th label='nombre' width='calc(100% - 585px)'>CLIENTE</Th>
            <Th width='160px'>MONTO</Th>
            <Th width='100px'>ESTATUS</Th>
            <Th width='135px'>ACCIONES</Th>
        </tr>
    }
    Row(p: GeneralFila) {
        return <FilaCotizacion con={this.con} key={"cot" + p.codigo + p.status} data={p} />
    }
    getItens() { return this.context.Cotizaciones; }
    set() { this.context.actCotizacion(); }
    getEstado() { return this.context.estCotizacion; }
    Actualizar() {
        const { hora } = this.getEstado();
        return <Col md={3} className='mr-auto d-flex flex-row-reverse'>
            <CotizacionExcel cotizacion={this.filter()} />
            <div style={{ fontSize: '12px', width: "200px", paddingLeft: '15px' }}>
                <strong>ACTUALIZADO:</strong> <br />
                {hora}
            </div>
        </Col>
    }
}
ListCotizaciones.contextType = CotizacionContext;
export default ListCotizaciones